import { render, staticRenderFns } from "./InviraRolesCopy.vue?vue&type=template&id=5392e00e&scoped=true"
import script from "./InviraRolesCopy.vue?vue&type=script&lang=js"
export * from "./InviraRolesCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5392e00e",
  null
  
)

export default component.exports